module.exports = {"TXTWCL_Watch_Trailer":{"id":"TXTWCL_Watch_Trailer","defaultMessage":"Előzetes megtekintése","flags":["TRACK"],"track":"Watch Trailer"}}